export default {
  term: '',
  termText: '',
  terms: [],
  startHour: 7,
  endHour: 22,
  collapsed: false,
  thin: false
}
